import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import PC from "./pages/pcIndex/index.js";
import Share from './pages/share/index';
// import Chat from "./pages/chat/index.js";
import "./index.css";
import "@ant-design/v5-patch-for-react-19";
import LanguageSwitcher from "./components/LanguageSwitcher.jsx";
// 设备检测和路由跳转组件

function App() {
  return (
      <Router>
          <div className="App" style={{width: "100%", height: "100%"}}>
              {/*<div style={{position: 'fixed', top: 12, right: 12, zIndex: 1000}}>*/}
              {/*    <LanguageSwitcher size="small"/>*/}
              {/*</div>*/}
              {/*<PC/>*/}
              <Routes>
                  <Route path="/" element={<PC/>}/>
                  <Route path="/share" element={<Share/>}/>
              </Routes>
          </div>
      </Router>
  );
}

export default App;
